var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H6C7.1 8 8 7.1 8 6V2C8 0.9 7.1 0 6 0H2C0.9 0 0 0.9 0 2V6C0 7.1 0.9 8 2 8ZM2 2H6V6H2V2Z",
    fill: "url(#paint0_linear_2979_9528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H6C7.1 8 8 7.1 8 6V2C8 0.9 7.1 0 6 0H2C0.9 0 0 0.9 0 2V6C0 7.1 0.9 8 2 8ZM2 2H6V6H2V2Z",
    fill: "#2C2A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6C7.1 18 8 17.1 8 16V12C8 10.9 7.1 10 6 10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18ZM2 12H6V16H2V12Z",
    fill: "url(#paint1_linear_2979_9528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6C7.1 18 8 17.1 8 16V12C8 10.9 7.1 10 6 10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18ZM2 12H6V16H2V12Z",
    fill: "#2C2A59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V6C10 7.1 10.9 8 12 8H16C17.1 8 18 7.1 18 6V2C18 0.9 17.1 0 16 0H12C10.9 0 10 0.9 10 2ZM16 6H12V2H16V6Z",
    fill: "url(#paint2_linear_2979_9528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V6C10 7.1 10.9 8 12 8H16C17.1 8 18 7.1 18 6V2C18 0.9 17.1 0 16 0H12C10.9 0 10 0.9 10 2ZM16 6H12V2H16V6Z",
    fill: "#2C2A59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.5V16.5C18 16.22 17.78 16 17.5 16H16.5C16.22 16 16 16.22 16 16.5V17.5C16 17.78 16.22 18 16.5 18H17.5C17.78 18 18 17.78 18 17.5Z",
    fill: "url(#paint3_linear_2979_9528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.5V16.5C18 16.22 17.78 16 17.5 16H16.5C16.22 16 16 16.22 16 16.5V17.5C16 17.78 16.22 18 16.5 18H17.5C17.78 18 18 17.78 18 17.5Z",
    fill: "#2C2A59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5V11.5C10 11.78 10.22 12 10.5 12H11.5C11.78 12 12 11.78 12 11.5V10.5C12 10.22 11.78 10 11.5 10H10.5C10.22 10 10 10.22 10 10.5Z",
    fill: "url(#paint4_linear_2979_9528)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5V11.5C10 11.78 10.22 12 10.5 12H11.5C11.78 12 12 11.78 12 11.5V10.5C12 10.22 11.78 10 11.5 10H10.5C10.22 10 10 10.22 10 10.5Z",
    fill: "#2C2A59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12H12.5C12.22 12 12 12.22 12 12.5V13.5C12 13.78 12.22 14 12.5 14H13.5C13.78 14 14 13.78 14 13.5V12.5C14 12.22 13.78 12 13.5 12Z",
    fill: "url(#paint5_linear_2979_9528)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12H12.5C12.22 12 12 12.22 12 12.5V13.5C12 13.78 12.22 14 12.5 14H13.5C13.78 14 14 13.78 14 13.5V12.5C14 12.22 13.78 12 13.5 12Z",
    fill: "#2C2A59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5V15.5C10 15.78 10.22 16 10.5 16H11.5C11.78 16 12 15.78 12 15.5V14.5C12 14.22 11.78 14 11.5 14H10.5C10.22 14 10 14.22 10 14.5Z",
    fill: "url(#paint6_linear_2979_9528)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5V15.5C10 15.78 10.22 16 10.5 16H11.5C11.78 16 12 15.78 12 15.5V14.5C12 14.22 11.78 14 11.5 14H10.5C10.22 14 10 14.22 10 14.5Z",
    fill: "#2C2A59"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18H13.5C13.78 18 14 17.78 14 17.5V16.5C14 16.22 13.78 16 13.5 16H12.5C12.22 16 12 16.22 12 16.5V17.5C12 17.78 12.22 18 12.5 18Z",
    fill: "url(#paint7_linear_2979_9528)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18H13.5C13.78 18 14 17.78 14 17.5V16.5C14 16.22 13.78 16 13.5 16H12.5C12.22 16 12 16.22 12 16.5V17.5C12 17.78 12.22 18 12.5 18Z",
    fill: "#2C2A59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16H15.5C15.78 16 16 15.78 16 15.5V14.5C16 14.22 15.78 14 15.5 14H14.5C14.22 14 14 14.22 14 14.5V15.5C14 15.78 14.22 16 14.5 16Z",
    fill: "url(#paint8_linear_2979_9528)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16H15.5C15.78 16 16 15.78 16 15.5V14.5C16 14.22 15.78 14 15.5 14H14.5C14.22 14 14 14.22 14 14.5V15.5C14 15.78 14.22 16 14.5 16Z",
    fill: "#2C2A59"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10H14.5C14.22 10 14 10.22 14 10.5V11.5C14 11.78 14.22 12 14.5 12H15.5C15.78 12 16 11.78 16 11.5V10.5C16 10.22 15.78 10 15.5 10Z",
    fill: "url(#paint9_linear_2979_9528)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10H14.5C14.22 10 14 10.22 14 10.5V11.5C14 11.78 14.22 12 14.5 12H15.5C15.78 12 16 11.78 16 11.5V10.5C16 10.22 15.78 10 15.5 10Z",
    fill: "#2C2A59"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14H17.5C17.78 14 18 13.78 18 13.5V12.5C18 12.22 17.78 12 17.5 12H16.5C16.22 12 16 12.22 16 12.5V13.5C16 13.78 16.22 14 16.5 14Z",
    fill: "url(#paint10_linear_2979_9528)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14H17.5C17.78 14 18 13.78 18 13.5V12.5C18 12.22 17.78 12 17.5 12H16.5C16.22 12 16 12.22 16 12.5V13.5C16 13.78 16.22 14 16.5 14Z",
    fill: "#2C2A59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2979_9528",
    x1: -10.0869,
    y1: 0.0664747,
    x2: -9.95395,
    y2: 28.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2979_9528",
    x1: -10.0869,
    y1: 10.0665,
    x2: -9.95395,
    y2: 38.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2979_9528",
    x1: -0.0868967,
    y1: 0.0664747,
    x2: 0.0460527,
    y2: 28.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2979_9528",
    x1: 13.4783,
    y1: 16.0166,
    x2: 13.5115,
    y2: 23.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2979_9528",
    x1: 7.47828,
    y1: 10.0166,
    x2: 7.51151,
    y2: 17.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2979_9528",
    x1: 9.47828,
    y1: 12.0166,
    x2: 9.51151,
    y2: 19.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2979_9528",
    x1: 7.47828,
    y1: 14.0166,
    x2: 7.51151,
    y2: 21.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2979_9528",
    x1: 9.47828,
    y1: 16.0166,
    x2: 9.51151,
    y2: 23.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2979_9528",
    x1: 11.4783,
    y1: 14.0166,
    x2: 11.5115,
    y2: 21.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2979_9528",
    x1: 11.4783,
    y1: 10.0166,
    x2: 11.5115,
    y2: 17.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2979_9528",
    x1: 13.4783,
    y1: 12.0166,
    x2: 13.5115,
    y2: 19.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6768AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2A59"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagar);
export default __webpack_public_path__ + "static/media/pagar.36ee1d4cbcb3723f43aedc17a0646f55.svg";
export { ForwardRef as ReactComponent };